import React, {FC, useEffect} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import Make1099Differences from 'components/blocks/make1099/Make1099Differences'
import Make1099Exceptions from 'components/blocks/make1099/Make1099Exceptions/Make1099Exceptions'
import Make1099Faq from 'components/blocks/make1099/Make1099Faq'
import Make1099How from 'components/blocks/make1099/Make1099How/Make1099How'
import Make1099Mistakes from 'components/blocks/make1099/Make1099Mistakes/Make1099Mistakes'
import Make1099What from 'components/blocks/make1099/Make1099What/Make1099What'
import Make1099When from 'components/blocks/make1099/Make1099When/Make1099When'
import Make1099Why from 'components/blocks/make1099/Make1099Why/Make1099Why'
import {Row, Col, Container} from 'components/elements/grid'
import {IMake1099Content} from 'pages/make-your-1099'
import Form1099 from 'src/components/blocks/forms/Form1099'
import {posthogTrack, klaviyoTrack} from 'src/utils'

import s from './TemplateCreateDocumentForm1099.module.scss'

const cx = cn.bind(s)

interface ITemplateCreateDocumentForm1099Props {
	className?: string
	content: IMake1099Content
}

const TemplateCreateDocumentForm1099: FC<ITemplateCreateDocumentForm1099Props> = ({
	className,
	content,
}) => {
	useEffect(() => {
		posthogTrack('[1099 FORM] Page opened')
		klaviyoTrack('Page opened', {page: '1099', href: window?.location?.href})
	}, [])

	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<Row>
					<Col xl={{span: 8, offset: 2}}>
						<LandingsTitle
							type="top"
							className={s.title}
							topClassName={s.titleTop}
							title={content.title}
						/>
					</Col>
				</Row>
			</Container>
			<Form1099 />

			<Make1099Why className={cx('why')} content={content.why} />
			<Make1099What className={cx('section', 'what')} content={content.what} />
			<Make1099How className={cx('section', 'how')} content={content.how} />
			<Make1099When className={cx('section', 'when')} content={content.when} />
			<Make1099Exceptions className={cx('section', 'exceptions')} content={content.exceptions} />
			<Make1099Mistakes className={cx('section', 'mistakes')} content={content.mistakes} />
			<Make1099Differences className={cx('section', 'differences')} content={content.differences} />
			<Make1099Faq className={cx('section', 'faq')} content={content.faq} />
		</div>
	)
}

TemplateCreateDocumentForm1099.displayName = 'TemplateCreateDocumentForm1099'

export default TemplateCreateDocumentForm1099
